import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { MANUAL_JOURNAL_ENTRY_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  jeMasterId: string;
  communityId: string;
}

const mutateUploadMJEExcel = async ({ communityId, jeMasterId }: mutateProps) => {
  return await axiosAuth.post(`${MANUAL_JOURNAL_ENTRY_API(communityId)}/submit-excel/${jeMasterId}`);
};

const useUploadMJEExcelMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
   mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUploadMJEExcel,
    ...queryParams,
  });

export default useUploadMJEExcelMutation;
